export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CUBEJS_API = process.env.REACT_APP_CUBEJS_API;
